<script lang="ts">
    import clsx from 'clsx';

    // Utils
    import { getBorderRadius } from '$lib/global/helper/border-radius';

    export let id: string | null = null;
    export let open = false;
    export let style = '';
    export let contentStyle = '';

    let dropdownContentClasses: string;
    let dropdownWrapperClasses: string;

    $: dropdownWrapperClasses = clsx('absolute flex right-0 left-0 top-full z-[1000] h-auto', {
        'pointer-events-none': !open,
        'pointer-events-auto': open,
    });

    $: dropdownContentClasses = clsx(
        getBorderRadius('dropdown'),
        contentStyle,
        'relative flex flex-col duration-[300ms] border shadow origin-top ease transform transition-all bg-white mt-2 mb-4 overflow-hidden',
        {
            'opacity-0 pointer-events-none scale-y-0': !open,
            'opacity-100 scale-y-100': open,
        },
    );
</script>

<div {id} class={`${dropdownWrapperClasses} ${style}`}>
    <div class={dropdownContentClasses}><slot /></div>
</div>
